var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_1169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.35 23.6401C18.5853 23.6401 23.64 18.5854 23.64 12.3501C23.64 6.11476 18.5853 1.06006 12.35 1.06006C6.1147 1.06006 1.06 6.11476 1.06 12.3501C1.06 18.5854 6.1147 23.6401 12.35 23.6401Z",
    stroke: "#ffffff",
    strokeWidth: 2.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.67 20.46L30.18 29.97",
    stroke: "#ffffff",
    strokeWidth: 2.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_1169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.24,
    height: 31.02,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconWhite);
export default __webpack_public_path__ + "static/media/search-icon-white.46f5b71dc3f6f9d3be79d1a44cc1f82a.svg";
export { ForwardRef as ReactComponent };